import styled from "styled-components";

export const Label = styled.p<{ black?: boolean }>`
  font-size: 14px;
  color: ${(props) => props.black ? props.theme.colors.unabacusblack : "white"};
`;

Label.defaultProps= {
  black: true,
};